import React from 'react'
import PropTypes from 'prop-types'
import { IonTextarea, IonItem } from '@ionic/react'
import { withFormikAdapter } from 'utils'
import classNames from 'classnames'
import { omit, startCase } from 'lodash'

const propTypes = {
  name: PropTypes.string.isRequired,
  isTouched: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  error: PropTypes.string,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  /** When 'outside', error is not passed to IonTextarea and is rendered below the field instead */
  errorPlacement: PropTypes.oneOf(['inside', 'outside']),
  /** Class for the error div when errorPlacement is 'outside' */
  errorClassName: PropTypes.string,
}

const defaultProps = {
  label: '',
  error: '',
  className: '',
  errorPlacement: 'inside',
  errorClassName: '',
}

function Textarea({
  name,
  label,
  isTouched,
  error,
  className,
  hidden,
  errorPlacement,
  errorClassName,
  ...rest
}) {
  const labelText = label ?? startCase(name)
  const showErrorOutside = errorPlacement === 'outside' && error
  return (
    <>
      <IonItem className="input-container" lines="none" hidden={hidden}>
        <IonTextarea
          className={classNames(className, {
            'ion-invalid': error,
            'ion-touched': isTouched,
          })}
          name={name}
          label={labelText}
          labelPlacement="stacked"
          errorText={showErrorOutside ? undefined : error}
          {...omit(rest, 'aria-describedby')} // uses built-in ionic error components
        ></IonTextarea>
      </IonItem>
      {showErrorOutside && (
        <div className={errorClassName || 'formik-field-error'} role="alert">
          {error}
        </div>
      )}
    </>
  )
}

Textarea.propTypes = propTypes
Textarea.defaultProps = defaultProps

export default withFormikAdapter()(Textarea)
